import { Component, OnInit } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { ContactsImportViewPage } from '../contacts-import-view/contacts-import-view.page';  

import { Contacts } from '@capacitor-community/contacts';
import { Plugins } from '@capacitor/core';
import { ActionSheetController } from '@ionic/angular';

@Component({
  selector: 'app-contacts-import',
  templateUrl: './contacts-import.page.html',
  styleUrls: ['./contacts-import.page.scss'],
})
export class ContactsImportPage implements OnInit {

  contacts = [];

  constructor(public modalCtrl: ModalController, public actionSheetController: ActionSheetController) {}  
  
  ngOnInit() {
    //this.loadContacts();
    this.retrieveListOfContacts();
  }

  dismiss() {  
    this.modalCtrl.dismiss();  
  }

  retrieveListOfContacts = async () => {
    const projection = {
      // Specify which fields should be retrieved.
      name: true,
      phones: true,
      emails: true,
      postalAddresses: true
    };

    const result = await Contacts.getContacts({
      projection,
    });

    // Order the contacts by name: given, family, display - lets use display
    result.contacts.sort((a, b) => (a.name.display > b.name.display) ? 1 : -1);

    this.contacts = result.contacts;
  };

  // async loadContacts() {
  //   Contacts.getContacts().then(results => {
  //     console.log(results.contacts);
  //     this.contacts = results.contacts;
  //   });
  // }

  async chooseContact(contact) {
    console.log('Choosing contact.');
    console.log(contact);
    const modal = await this.modalCtrl.create({  
      component: ContactsImportViewPage,
      componentProps: { contactToView: contact },
      canDismiss: true,
      presentingElement: await this.modalCtrl.getTop() // Get the top-most ion-modal
    });

    modal.onDidDismiss()
      .then((data) => {

        const contact = data.data;

        if (contact != null) {
          // We can now dismiss contacts import modal, returning with the contact to pre-populate
          // the contacts create modal screen.
          console.log(contact);

          // Dismiss.
          this.modalCtrl.dismiss(contact);  
        }
        else {
          // User has dismissed viewing the Phone Contact - do nothing until they choose another.
        }
    });
    return await modal.present();
  }

  handleSearch(event) {
    // Filter the contacts based on the search term.
    // Check if the search term is empty, if so, retrieve all contacts.
    // If not, filter the contacts based on the search term
    const searchTerm = event.target.value.toLowerCase();
    console.log(searchTerm);

    if (searchTerm === '') {
      this.retrieveListOfContacts();
    } else {
      this.contacts = this.contacts.filter(contact => {
        if (contact.name.display) {
          if (contact.name.display.toLowerCase().indexOf(searchTerm) !== -1) {
            return contact;
          }
        }
      });
    }
  }

}